module.exports = __webpack_public_path__ + "asset/image-Property-1-Piggy-Bank-d30fcf57f1c08915.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Property-1-Piggy-Bank.svg
// module id = 3jOQ
// module chunks = 0